import React from "react";
import CircularProgress from '@mui/material/CircularProgress';

export default function ButtonLoader({color}) {

    return (
        <CircularProgress size={24} sx={{color: `${color || '#1976d2'}`}} />
    )
};